import { IOrcamento } from 'app/types/IOrcamento';
import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItensAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"


import globalMU from "globalMU"

declare var window: any

export type AlterarDataMarcadaEntregaItemInput = {
    identificadorItem: number,
    dataMarcadaEntrega: string,
    itemLegado?: any
}

export async function alterarDataMarcadaEntregaItem(input: AlterarDataMarcadaEntregaItemInput) {
    try {
        globalMU.blockUI({ tryPassiveLoading: true })

        const orcamentoAtualizado = await microuniversoApi.Orcamento.alterarDataMarcadaEntregaItem(input.identificadorItem, input.dataMarcadaEntrega,
            store.getState().orcamento.IdentificadorOrcamento)

        const atualizarRedux = (orcamentoAtualizado: IOrcamento) => {
            const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]
            store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
            store.dispatch(atualizarItensAction({ itens: orcamentoAtualizado.ItensOrcamento, acao: "SOBRESCREVER", corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL }))
        }

        if (!("HasErrors" in orcamentoAtualizado)) {
            if ((orcamentoAtualizado as IOrcamento).ItensOrcamento !== undefined) {
                atualizarRedux(orcamentoAtualizado as IOrcamento)
            }
        }

        //const atualizarOrcamentoLegado = () => {
        //const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem)
        //const orcamentoLegado = window.orcamentoController.model
        //const itemLegado = input?.itemLegado ?? orcamentoLegado.get('ItensOrcamento').models.find(item => item.get('Identificador') == input.identificadorItem)

        //itemLegado.atualizar(itemAtualizado)
        //orcamentoLegado.atualizar(orcamentoAtualizado)
        //}

        //atualizarRedux()
        //atualizarOrcamentoLegado()
    } finally {
        globalMU.unblockUI()
    }
}